module.exports = __webpack_public_path__ + "static/media/Pixel4_FR.png?v=e015a60d";